import React from "react";
import { Card, Skeleton, Space } from "antd";

export default function DashboardSkeleton() {
    return (
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
            <Card>
                <Skeleton avatar={{ size: 120, shape: "circle" }} active paragraph={{ rows: 3 }} />
            </Card>
            <Card>
                <Skeleton active title paragraph={{ rows: 4 }} />
            </Card>
        </Space>
    );
}
